import { METAMASK,BLOCKCHAINCONTRACT } from './constants'

/*** REDUCER DEFINATION FOR SEARCH IN HEADER SECTION ***/
export const metaMaskReducer = (state = {}, action) => {
    console.log('In reducer',action)
    switch (action.type) {
        case METAMASK:
            return  { ...state, metamask:action.data  };
        default:
            return state;
    }
}
/*** REDUCER DEFINATION FOR BLOCKChain contract ***/
export const blockchainContractReducer = (state = {}, action) => {
    console.log('In reducer',action)
    switch (action.type) {
        case BLOCKCHAINCONTRACT:
            return  { ...state, contract:action.data  };
        default:
            return state;
    }
}

/*** REDUCER DEFINATION FOR EMPLOYEE LIST ***/
// export const employeeListReducer = (state = {}, action) => {

//     switch (action.type) {
//         case EMPLOYEES:
//             return  { ...state, employeesList : action.employees } ;
//         default:
//             return state;
//     }
// }

